import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-notification-message',
    templateUrl: './notification-message.component.html',
    styleUrls: ['./notification-message.component.scss'],
    standalone: false
})
export class NotificationMessageComponent implements OnInit {
  @Input()
  successMessage: string = ""
  @Input()
  errorMessage: string = ""

  constructor() { }

  ngOnInit(): void { 
    console.info('ngoninit')
  }


}
